// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyDetail_faculty-detail__NTWdf {
  display: flex;
  justify-content: space-between;
}
.FacultyDetail_faculty-detail__NTWdf .ant-tag.ant-tag-has-color {
  color: grey;
}
.FacultyDetail_faculty-detail__NTWdf .FacultyDetail_academic-result__S2Lhv {
  width: 75%;
}
.FacultyDetail_faculty-detail__NTWdf .FacultyDetail_academic-result__S2Lhv .FacultyDetail_lectures__dHKLN {
  margin-bottom: 30px;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}
.FacultyDetail_faculty-detail__NTWdf .FacultyDetail_academic-result__S2Lhv .FacultyDetail_lectures__dHKLN .FacultyDetail_section-title__OId5g {
  margin-top: 15px;
  font-size: 20px;
  font-weight: bold;
  text-transform: capitalize;
  margin-bottom: 30px;
}
@media only screen and (min-width: 901px) and (max-width: 1024px) {
  .FacultyDetail_faculty-detail__NTWdf .FacultyDetail_academic-result__S2Lhv {
    width: 70%;
  }
}
@media only screen and (max-width: 900px) {
  .FacultyDetail_faculty-detail__NTWdf {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .FacultyDetail_faculty-detail__NTWdf .FacultyDetail_academic-result__S2Lhv {
    width: 97%;
    margin-top: 10px;
  }
  .FacultyDetail_faculty-detail__NTWdf .FacultyDetail_academic-result__S2Lhv .FacultyDetail_lectures__dHKLN {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/FacultyDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;AAAE;EACE,WAAA;AAEJ;AAAE;EACE,UAAA;AAEJ;AADI;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAGN;AADM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;AAGR;AACE;EACE;IACE,UAAA;EACJ;AACF;AACE;EA5BF;IA6BI,aAAA;IACA,sBAAA;IACA,mBAAA;EAEF;EADE;IACE,UAAA;IACA,gBAAA;EAGJ;EAFI;IACE,aAAA;EAIN;AACF","sourcesContent":[".faculty-detail {\n  display: flex;\n  justify-content: space-between;\n  :global(.ant-tag.ant-tag-has-color) {\n    color: grey;\n  }\n  .academic-result {\n    width: 75%;\n    .lectures {\n      margin-bottom: 30px;\n      padding: 25px;\n      border-radius: 10px;\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n\n      .section-title {\n        margin-top: 15px;\n        font-size: 20px;\n        font-weight: bold;\n        text-transform: capitalize;\n        margin-bottom: 30px;\n      }\n    }\n  }\n  @media only screen and (min-width: 901px) and (max-width: 1024px) {\n    .academic-result {\n      width: 70%;\n    }\n  }\n  @media only screen and (max-width: 900px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    .academic-result {\n      width: 97%;\n      margin-top: 10px;\n      .lectures {\n        display: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-detail": `FacultyDetail_faculty-detail__NTWdf`,
	"academic-result": `FacultyDetail_academic-result__S2Lhv`,
	"lectures": `FacultyDetail_lectures__dHKLN`,
	"section-title": `FacultyDetail_section-title__OId5g`
};
export default ___CSS_LOADER_EXPORT___;
